import { GreenhouseJob } from '@/libs/greenhouse/greenhouse';

const SaveJobButton = ({ job }: { job: GreenhouseJob }) => {
  return (
    <button
      className="group hover:cursor-pointer relative z-2 w-10 h-10 flex items-center justify-center"
      type="button">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="17"
        viewBox="0 0 14 17"
        className="group-hover:fill-[#1E1E1E] fill-none">
        <path
          d="M12.6667 16L6.83333 11.8333L1 16V2.66667C1 2.22464 1.17559 1.80072 1.48816 1.48816C1.80072 1.17559 2.22464 1 2.66667 1H11C11.442 1 11.866 1.17559 12.1785 1.48816C12.4911 1.80072 12.6667 2.22464 12.6667 2.66667V16Z"
          stroke="#1E1E1E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="sr-only">Bookmark {job.title}</span>
    </button>
  );
};

export default SaveJobButton;
